<template>
  <div class="p-4 max-w-xl mx-auto">
    <nav class="flex justify-between mb-6">
      <h1 class="text-xl font-bold">Notes App</h1>
      <div v-if="isLoggedIn">
        <button @click="logout" class="text-red-500">Выйти</button>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const isLoggedIn = computed(() => {
  return !!localStorage.getItem("token");
});

const logout = () => {
  localStorage.removeItem("token");
  router.push("/login");
};
</script>
